import axios from "axios";
import { del, get, patch, post, put } from "./methods";
import { getDeviceId } from "../utils/deviceId";
import { getApiBaseUrl, getTenantId } from "./tenantApi";

export const loginPostApi = async (data) => {
  try {
    const response = await post("/login", data);
    return response;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};
export const creatorForgotPasswordApi = async (email) => {
  return post("/creators/forgot-password", { email });
};

export const creatorVerifyOtpApi = async (email, otp) => {
  return post("/creators/verify-otp", { email, otp });
};

export const creatorResetPasswordApi = async (email, otp, new_password) => {
  return post("/creators/reset-password", { email, otp, new_password });
};

export const refreshTokenApi = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const token = localStorage.getItem("token");
  if (!refreshToken) throw new Error("No refresh token found");

  const deviceId = getDeviceId();
  const deviceType = "web";

  const headers = {
    "X-Device-Id": deviceId,
    "X-Device-Type": deviceType,
    "Authorization": `Bearer ${token}`,
  };
  if (typeof window !== "undefined" && window.location?.hostname) {
    headers["X-Tenant-Domain"] = window.location.hostname;
  }
  const tenantId = getTenantId();
  if (tenantId) headers["X-Tenant-Id"] = tenantId;

  const baseUrl = getApiBaseUrl();
  try {
    const response = await axios.post(
      `${baseUrl}/refresh-token`,
      { refresh_token: refreshToken },
      { headers }
    );

    const data = response?.data?.data;

    if (!data?.token || !data?.expire_date) {
      throw new Error("Invalid refresh response");
    }

    localStorage.setItem("expireDate", data.expire_date);
    localStorage.setItem("refreshToken", data.refresh_token);
    localStorage.setItem("token", data.token);

    return {
      token: data.token,
      expireDate: data.expire_date,
    };
  } catch (error) {
    console.error("Token refresh failed:", error);
    throw error;
  }
};
export const creatorsloginApi = async (data) => {
  try {
    const response = await post("creators/login", data);
    const token = response?.data?.data?.token;
    if (token) {
      localStorage.setItem("token", token);
      return token;
    } else {
      throw new Error("Token not found in response");
    }
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

export const creatorSignUpApi = async (data) => {
  return await get(`/creators/signup/${data}`);
};
export const creatorsRegister = async (data) => {
  try {
    const response = await post("/creators/register", data);
    return response;
  } catch (error) {
    console.error("Registration failed:", error);
    throw error;
  }
};
export const getCreatorLicensingModels = async () => {
  return await get("/creators/licensing-models");
};
// Public — used on the signup form so a not-yet-registered creator can
// preview the current agreement template before certifying.
export const getPublicAgreementTemplate = async () => {
  return await get("/creators/agreement-template");
};
// Creator-only: resubmit the application after an admin's "Request
// correction" (or just to fix something while still Pending). Same fields as
// creatorsRegister (FormData, since it can carry new profile/banner/document
// files), minus email/password. Moves the account back to "Pending" and
// clears the admin's note server-side.
export const resubmitCreatorApplication = async (data) => {
  try {
    const response = await post("/creators/resubmit", data);
    return response;
  } catch (error) {
    console.error("Resubmit failed:", error);
    throw error;
  }
};

export const CreatorApi = async (data) => {
  try {
    const response = await post("/creators/create", data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const creatorListApi = async (
  data = {},
  perpage = 10,
  page = 1,
  search = "",
) => {
  try {
    const response = await get(
      `/creators/list?perpage=${perpage}&page=${page}&search=${search ? search : ""
      }`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const UploadImage = async (data) => {
  try {
    const response = await post("/image-upload", data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const UploadMovie = async (data) => {
  try {
    const response = await post("/file-upload", data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const UploadRequest = async (data) => {
  try {
    const response = await post("/videos/upload-request", data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const UploadAcknowledge = async (data) => {
  try {
    const response = await post("/videos/upload-acknowledge", data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/** Start Gemini video metadata analysis (multipart FormData or JSON body). */
export const startVideoAiAnalysis = async (data, config = {}) => {
  try {
    return await post("/videos/ai-analyze", data, config);
  } catch (error) {
    console.error("Video AI analyze start failed:", error);
    throw error;
  }
};

/** Poll an in-flight video AI analysis job. */
export const getVideoAiAnalysisStatus = async (jobId) => {
  try {
    return await get(`/videos/ai-analyze/${jobId}`);
  } catch (error) {
    console.error("Video AI analyze status failed:", error);
    throw error;
  }
};
// --- In-flight TUS upload tracking -------------------------------------------
// Report real byte progress to the server so it survives a reload and is visible
// to other admins. Called on a throttle by the upload manager, so failures are
// non-fatal and intentionally not logged loudly.
export const UploadHeartbeat = async (videoId, body) =>
  post(`/videos/${videoId}/upload-heartbeat`, body);

// Mint a fresh presigned TUS signature for an upload already in progress. This is
// what stops large uploads dying with a 401 when the original signature expires.
export const UploadResign = async (videoId, body = {}) =>
  post(`/videos/${videoId}/upload-resign`, body);

// Abandon an upload and clean up the half-written video in Bunny.
export const UploadCancel = async (videoId) =>
  post(`/videos/${videoId}/upload-cancel`, {});

export const dashBoardCardApi = async (data) => {
  try {
    const response = await get("/dashboard/admin", data);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const submissionApi = async (filters = {}, perpage = 10, page = 1) => {
  try {
    const params = { ...filters, perpage, page };
    const response = await get("/submissions", { params });
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submissionSeriesEpisodesApi = async (seriesId) => {
  try {
    const response = await get(`/submissions/series/${seriesId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const movieListApi = async (data) => {
  try {
    const response = await get(
      "/library?content-type=Movie&perpage=1000",
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const MovieDataList = async (id, data, queryParams = {}) => {
  try {
    // Add query parameters to the URL if provided
    const queryString =
      Object.keys(queryParams).length > 0
        ? "?" + new URLSearchParams(queryParams).toString()
        : "";
    const response = await get(`/video/${id}${queryString}`, data);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { status: "error", message: "Video not found." };
    } else {
      return {
        status: "error",
        message: error.message || "An error occurred.",
      };
    }
  }
};

export const moviesUpdate = async (id, data, queryParams = {}) => {
  try {
    const response = await post(`admin/update-content`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const GenresList = async (data = {}, limit = 200, search = "") => {
  try {
    const response = await get(`/genres?limit=${limit}&search=${search}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const GenresListPage = async (data = {}, perpage = 5, page = 1) => {
  try {
    const response = await get(
      `/genres/list?perpage=${perpage}&page=${page}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const GenresCreate = async (data) => {
  try {
    const response = await post(`/genres`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const updateGenres = async (id, data) => {
  try {
    const response = await post(`/genres/${id}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const GenresDelete = async (id, data) => {
  try {
    const response = await del(`/genres/${id}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const categoriesList = async (id, data) => {
  try {
    const response = await get(`/content-type`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const ratingList = async () => {
  try {
    const response = await get(`/rating-list`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const ratingCreate = async (data) => {
  try {
    const response = await post(`/rating-list`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const ratingUpdate = async (id, data) => {
  try {
    const response = await post(`/rating-list/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const ratingDelete = async (id) => {
  try {
    const response = await del(`/rating-list/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const dropDownAdminList = async () => {
  try {
    const response = await get("/admin/filter/library");
    return response;
  } catch (error) {
    throw error;
  }
};
export const dropDownCreatorList = async () => {
  try {
    const response = await get("/creators/filter/library/");
    return response;
  } catch (error) {
    throw error;
  }
};
export const getLibraryByCategory = async (
  name,
  data = {},
  date = "",
  creator = "",
  rating = "",
  genre = "",
  perpage = 20,
  page = 1,
  search = "",
  qcStatus = "",
) => {
  try {
    const response = await get(
      `/library?content-type=${name}&date=${date ? date : ""}&creator=${creator ? creator : ""
      }&rating=${rating ? rating : ""}&genre=${genre ? genre : ""
      }&perpage=${perpage}&page=${page}&search=${encodeURIComponent(search || "")
      }&qc_status=${qcStatus ? qcStatus : ""}`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getGlobalSearch = async (data) => {
  try {
    const response = await get(`/search?query=${data}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getPillCategorySearch = async (data) => {
  try {
    const response = await get(`/pill-category-search?query=${data}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const adminFilterSearch = async (data) => {
  try {
    const response = await get(`/admin/filter/${data ? data : ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const adminEpisodeFilterSearch = async (id, data) => {
  try {
    const response = await get(
      `/admin/filter/${id ? id : ""}/${data ? data : ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const adminSeasonFilterSearch = async (data, id) => {
  try {
    const response = await get(
      `/admin/filter/${data ? data : ""}/${id ? id : ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const creatorFilterSearch = async (data) => {
  try {
    const response = await get(`/creators/filter/${data ? data : ""}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const creatorEpisodeFilterSearch = async (id, data) => {
  try {
    const response = await get(
      `/creators/filter/${id ? id : ""}/${data ? data : ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const creatorSeasonFilterSearch = async (data, id) => {
  try {
    const response = await get(
      `/creators/filter/${data ? data : ""}/${id ? id : ""}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateTableData = async (id, payload) => {
  try {
    const response = await post(`/update-video/${id}`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteVideo = async (id) => {
  try {
    const response = await del(`/delete-video/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const urlUpload = async (data) => {
  try {
    const response = await post("/url-upload", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addNewSeries = async (data) => {
  try {
    const response = await post("/series/create", data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const seriesListApi = async (
  data = {},
  date = "",
  creator = "",
  rating = "",
  genre = "",
  perpage = 20,
  page = 1,
  search = "",
  seriesFormat = "",  
  qcStatus = "",
) => {
  try {
    const response = await get(
      `series/list?perpage=${perpage}&page=${page}&date=${date ? date : ""}&creator=${creator ? creator : ""}&rating=${rating ? rating : ""}&genre=${genre ? genre : ""}&search=${search ? search : ""}&series_format=${seriesFormat ? seriesFormat : ""}&qc_status=${qcStatus ? qcStatus : ""}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const addNewSeason = async (seriesId, data) => {
  try {
    const response = await post(`/series/${seriesId}/seasons/create`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const seasonListApi = async (
  seriesId,
  data = {},
  date = "",
  creator = "",
  rating = "",
  genre = "",
  search = "",
  perpage = 20,
  page = 1,
) => {
  try {
    const response = await get(
      `/series/${seriesId}/seasons/list?perpage=${perpage}&page=${page}&date=${date ? date : ""
      }&creator=${creator ? creator : ""}&rating=${rating ? rating : ""
      }&genre=${genre ? genre : ""}&search=${search ? search : ""}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const episodeListApi = async (
  seriesId,
  seasonId,
  data = {},
  date = "",
  creator = "",
  rating = "",
  genre = "",
  search = "",
  perpage = 20,
  page = 1,
) => {
  try {
    const response = await get(
      `/series/${seriesId}/seasons/${seasonId}/episodes?date=${date ? date : ""
      }&creator=${creator ? creator : ""}&rating=${rating ? rating : ""
      }&genre=${genre ? genre : ""}&search=${search ? search : ""}`,
      {
        params: {
          perpage,
          page,
          ...data,
        },
      },
    );
    return response;
  } catch (error) {
    console.error("episodeListApi error:", error);
    return { data: { data: [] } };
  }
};

export const addNewEpisode = async (seriesId, seasonId, data) => {
  try {
    const response = await post(
      `/series/${seriesId}/seasons/${seasonId}/episodes`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const prefillSeriesListApi = async (data) => {
  try {
    const response = await get("series/all-list", data);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const prefillSeasonListApi = async (seriesId, data) => {
  try {
    const response = await get(`/series/${seriesId}/seasons/all-list`, data);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const seriesDelete = async (id) => {
  try {
    const response = await del(`/series/delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const qc_status = async (id, data) => {
  try {
    const response = await post(`qc-change/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const seriesUpdate = async (id, data) => {
  try {
    const response = await post(`/admin/update-content/series/${id}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const SeriesShowApi = async (id, data) => {
  try {
    const response = await get(`/series/${id}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const seasonDelete = async (seriesId, seasonId) => {
  try {
    return await del(`/series/${seriesId}/seasons/delete/${seasonId}`);
  } catch (err) {
    throw err;
  }
};
export const SeasonShowApi = async (seriesId, seasonId) => {
  try {
    const response = await get(`/series/${seriesId}/seasons/${seasonId}`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getFilter = async (category, date, creator, rating) => {
  try {
    const response = await get(
      `library?perpage=&page=&content-type=${category}&date=${date}&creator=${creator}&rating=${rating}`,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const seasonUpdate = async (seriesId, seasonId, data) => {
  try {
    const response = await post(
      `/series/${seriesId}/seasons/update/${seasonId}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const episodeDelete = async (id) => {
  try {
    return await del(`/delete-video/${id}`);
  } catch (err) {
    throw err;
  }
};
export const pillCategoriesApi = async (data) => {
  try {
    const response = await post("/pill-categories", data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const pillCategoriesList = async (data = {}, perpage = 20, page = 1) => {
  try {
    const response = await get(
      `/pill-categories?perpage=${perpage}&pagepill-categories?&page=${page}`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const pillCategoriesDelete = async (id, data) => {
  try {
    const response = await del(`/pill-categories/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const pillCategoriesUpdate = async (id, data) => {
  try {
    const response = await post(`pill-categories/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const singlePillCategories = async (id, data) => {
  try {
    const response = await get(`pill-categories/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const userList = async (
  data = {},
  perpage = 20,
  page = 1,
  search = "",
  filters = {},
) => {
  try {
    const params = new URLSearchParams({
      perpage,
      page,
      search: search || "",
    });
    // Only append filters that are actually set, so an empty dropdown
    // ("All") doesn't constrain the query.
    if (filters.user_type) params.set("user_type", filters.user_type);
    if (filters.status) params.set("status", filters.status);
    if (filters.platform) params.set("platform", filters.platform);
    if (filters.date) params.set("date", filters.date);
    if (filters.signup_state) params.set("signup_state", filters.signup_state);

    const response = await get(`/subscribers/list?${params.toString()}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const userDelete = async (id) => {
  try {
    return await del(`/subscribers/delete/${id}`);
  } catch (err) {
    throw err;
  }
};
export const userUpdate = async (data, id) => {
  try {
    const response = await post(`/subscribers/update/${id}`, data);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const userCreate = async (data) => {
  try {
    const response = await post(`/subscribers/create`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
// Cancel an admin-granted (bypass) Premium immediately -> moves user to Standard/Free.
export const userCancelPremium = async (id) => {
  try {
    const response = await post(`/subscribers/cancel-premium/${id}`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const userProfileUpdate = async (data) => {
  try {
    const response = await post(`/profile-img`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getUserProfile = async (data) => {
  try {
    const response = await get(`/profile`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creator-only: fetch full profile incl. channel (channel_name/description) so
// the Edit Profile modal can pre-fill the same fields the signup form collects.
export const creatorGetProfile = async (data) => {
  try {
    const response = await get(`/creators/profile`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creator-only: submit a signature for the agreement — a FormData with
// either a "signature_image" file (from the upload-a-photo path) or a
// "signature_data_url" text field (a base64 PNG from the canvas pad).
// Advances agreement_status straight to SIGNED on success.
export const submitSignature = async (formData) => {
  try {
    const response = await post("/creators/agreement/sign-document", formData);
    return response;
  } catch (error) {
    console.error("Error submitting signature:", error);
    throw error;
  }
};

// Creator-only: fetch the Content Licensing & Revenue Share Agreement PDF
// generated from this creator's own signup submission and hand back a blob:
// URL the caller can render in an <iframe> (in-page popup) or navigate to.
// The caller owns the URL's lifetime — revoke it (window.URL.revokeObjectURL)
// once the popup closes. 404s (via the caller's catch) if they haven't
// submitted License terms yet.
export const getMyAgreementPdfUrl = async () => {
  try {
    const response = await get(`/creators/agreement/pdf`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    return window.URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching agreement PDF:", error);
    throw error;
  }
};

// Public: the agreement PDF, for the signup form's preview when no
// agreement template has been uploaded.
// Public: the agreement name this tenant's creators sign (matches the PDF).
export const getAgreementInfo = async () => {
  const response = await get(`/creators/agreement-info`);
  return response?.data?.data || null;
};

export const getAgreementPreviewPdfUrl = async () => {
  const response = await get(`/creators/agreement-preview`, {
    responseType: "blob",
  });
  const blob = new Blob([response.data], { type: "application/pdf" });
  return window.URL.createObjectURL(blob);
};

// Admin-only: same as getMyAgreementPdfUrl but for any creator by id
// (users.view-gated on the backend) — used on the admin CreatorDetail page.
export const getAdminAgreementPdfUrl = async (creatorId) => {
  try {
    const response = await get(`/creators/${creatorId}/agreement/pdf`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "application/pdf" });
    return window.URL.createObjectURL(blob);
  } catch (error) {
    console.error("Error fetching creator agreement PDF:", error);
    throw error;
  }
};

// Admin-only: VH2's countersignature on a creator's agreement — same
// draw-or-upload FormData shape as submitSignature (creator-side), posted
// against this creator's id. Independent of agreement_status.
export const submitAdminSignature = async (creatorId, formData) => {
  try {
    const response = await post(`/creators/${creatorId}/agreement/countersign`, formData);
    return response;
  } catch (error) {
    console.error("Error submitting countersignature:", error);
    throw error;
  }
};

// Admin-only: edit the revenue split / payment terms a creator submitted at
// signup. Reflected in the next-generated agreement PDF on tenants using the
// standard agreement template (not the fixed-terms GRIEF TV template).
export const updateCreatorRevenueShare = async (creatorId, data) => {
  try {
    const response = await post(`/creators/${creatorId}/revenue-share`, data);
    return response;
  } catch (error) {
    console.error("Error updating revenue share:", error);
    throw error;
  }
};

// Admin-only: mark a creator's agreement as sent (advances agreement_status
// to SENT_TO_CREATOR — no email is sent, just the tracked status).
// Admin-only: upload/replace the agreement template file used to generate
// creator agreements. Stored on Bunny CDN; not yet wired into the actual
// PDF rendering (AgreementPdfService still uses its own hardcoded layout).
export const uploadAgreementTemplate = async (file) => {
  try {
    const formData = new FormData();
    formData.append("template", file);
    const response = await post("/admin/agreement-template", formData);
    return response;
  } catch (error) {
    console.error("Error uploading agreement template:", error);
    throw error;
  }
};

export const getAgreementTemplate = async () => {
  try {
    const response = await get("/admin/agreement-template");
    return response;
  } catch (error) {
    console.error("Error fetching agreement template:", error);
    throw error;
  }
};

export const sendAgreementToCreator = async (creatorId) => {
  try {
    const response = await post(`/creators/${creatorId}/agreement/send`);
    return response;
  } catch (error) {
    console.error("Error marking agreement sent:", error);
    throw error;
  }
};

// Admin-only: re-email the creator a copy of their fully executed agreement
// (PDF attached). Only valid once both sides have signed.
export const resendSignedAgreement = async (creatorId) => {
  try {
    const response = await post(`/creators/${creatorId}/agreement/resend`);
    return response;
  } catch (error) {
    console.error("Error resending signed agreement:", error);
    throw error;
  }
};

// Admin-only: manually mark a creator's agreement as signed (advances
// agreement_status to SIGNED — the signature itself is collected outside
// this app for now).
export const markAgreementSigned = async (creatorId) => {
  try {
    const response = await post(`/creators/${creatorId}/agreement/sign`);
    return response;
  } catch (error) {
    console.error("Error marking agreement signed:", error);
    throw error;
  }
};

// Creator-only: update name, phone, bio, profile_img, channel_name,
// channel_description. Send a plain JSON object.
export const creatorProfileUpdate = async (data) => {
  try {
    const response = await post(`/creators/profile`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creator-only: change password. Expects { current_password, new_password }.
export const creatorChangePassword = async (data) => {
  try {
    const response = await post(`/creators/change-password`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const deleteUserProfile = async (data) => {
  try {
    const response = await del(`/delete-profile-img`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const userShow = async (data, id) => {
  try {
    const response = await get(`/subscribers/show/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

// Full subscriber detail for the CMS user-detail page (header stats,
// subscription, account, viewing activity, devices, billing history).
export const userDetail = async (id) => {
  try {
    const response = await get(`/subscribers/detail/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSubscriptionAnalytics = async () => {
  try {
    const response = await get(`/admin/subscriptions/analytics`, {});
    return response.data;
  } catch (error) {
    console.error("Error fetching subscription analytics:", error);
    throw error;
  }
};
export const getSubscriptionDetails = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
  platform = "",
} = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    if (platform) params.set("platform", platform);
    const response = await get(`/admin/subscriptions/details?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subscription details:", error);
    throw error;
  }
};

export const getSettingsSubscription = async () => {
  try {
    const response = await get(`/config`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subscription analytics:", error);
    throw error;
  }
};
export const postSettingsSubscription = async (configData) => {
  try {
    const response = await post(`/config`, configData);

    return response.data;
  } catch (error) {
    console.error("Error updating subscription settings:", error);
    throw error;
  }
};

export const patchSettingsField = async (fieldData) => {
  try {
    const response = await patch(`/config/field`, fieldData);

    return response.data;
  } catch (error) {
    console.error("Error updating configuration field:", error);
    throw error;
  }
};
export const getAdManagement = async () => {
  try {
    const response = await get(`/ads`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const postAdManagement = async (id, data) => {
  try {
    const response = await patch(`/ads/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getWebHook = async (page, perpage) => {
  try {
    const response = await get(`/webhook/events?page=${page}&limit=${perpage}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching webhooks:", error);
    throw error;
  }
};

// `mediaType` ("video" | "image") disambiguates the id: videos and images use
// separate autoincrement sequences, so the same number often exists in both
// tables. Without it the server cannot tell which one is meant and refuses.
// The media list returns media_type on every item, so always pass it.
export const mediaDelete = async (id, mediaType) => {
  try {
    const qs = mediaType ? `?media_type=${encodeURIComponent(mediaType)}` : "";
    return await del(`/media/${id}${qs}`);
  } catch (err) {
    throw err;
  }
};
export const getProgressStatus = async (id, refresh = true) => {
  try {
    const response = await get(
      `/video/${id}/progress?refresh=${refresh ? "true" : "false"}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSections = async (page = 1, limit = 10) => {
  try {
    const response = await get(`/sections?page=${page}&limit=${limit}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getWidgetTypes = async () => {
  try {
    const response = await get(`/widget-types`);
    return response;
  } catch (error) {
    throw error;
  }
};
// Theme settings live on the same `configs` row as the enable_* flags -- see
// backend src/routes/config.js -- so these are nested under /config rather
// than a separate top-level resource.
export const getTheme = async () => {
  try {
    const response = await get(`/config/theme`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateTheme = async (data) => {
  try {
    const response = await patch(`/config/theme`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const addCustomAccentColor = async (color) => {
  try {
    const response = await post(`/config/theme/custom-colors`, { color });
    return response;
  } catch (error) {
    throw error;
  }
};
export const removeCustomAccentColor = async (color) => {
  try {
    const response = await del(`/config/theme/custom-colors/${encodeURIComponent(color)}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const addCustomBackground = async (color) => {
  try {
    const response = await post(`/config/theme/custom-backgrounds`, { color });
    return response;
  } catch (error) {
    throw error;
  }
};
export const removeCustomBackground = async (color) => {
  try {
    const response = await del(`/config/theme/custom-backgrounds/${encodeURIComponent(color)}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getAnalyticsDashboard = async (platform) => {
  try {
    const response = await get(`/get-analytics?platform=${platform}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const createSections = async (data) => {
  try {
    const response = await post(`/sections`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateSections = async (id, data) => {
  try {
    const response = await post(`/sections/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteSections = async (id) => {
  try {
    const response = await del(`/sections/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const createCategories = async (id, data) => {
  try {
    const response = await post(`/sections/${id}/categories`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCategories = async (id, data) => {
  try {
    const response = await get(`/sections/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSectionVersions = async (id) => {
  try {
    const response = await get(`/sections/${id}/versions`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getSectionPendingChanges = async (id) => {
  try {
    const response = await get(`/sections/${id}/pending-changes`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const restoreSectionVersion = async (id, versionId) => {
  try {
    const response = await post(`/sections/${id}/versions/${versionId}/restore`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getIcons = async () => {
  try {
    const response = await get(`/global/icons`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const swapOrder = async (data) => {
  try {
    const response = await post(`/sections/swap-order`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCategoyiesList = async (data) => {
  try {
    const response = await post(`/sections/swap-order`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCategories = async (id, data) => {
  try {
    const response = await post(`/sections/categories/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
// Publishing form's Category (page) + Sub Category (rail) dropdowns assign a
// Movie/Series into an Experience-Builder SectionCategory by pushing its id
// into that category's `contents` array -- there's no content->category
// relation, so this is the join. `contents` on the backend REPLACES (doesn't
// merge), so we read the category's current contents before writing back.
// `contentId` is a content ref: a movie id, or a series id negated (toSeriesRef
// in utils/contentRef.js) so it can't collide with a movie of the same id.
export const addContentToCategory = async (sectionId, categoryId, contentId) => {
  try {
    const sectionResponse = await getCategories(sectionId);
    const categories = sectionResponse?.data?.data?.categories || [];
    const target = categories.find((c) => String(c.id) === String(categoryId));
    if (!target) return null;

    const existingContents = Array.isArray(target.contents) ? target.contents : [];
    if (existingContents.includes(contentId)) return sectionResponse;

    const response = await updateCategories(target.id, {
      contents: [...existingContents, contentId],
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// Reverse of addContentToCategory: drops one content ref from the category's
// hand-picked `contents` (the backend then rebuilds all_contents).
export const removeContentFromCategory = async (sectionId, categoryId, contentId) => {
  try {
    const sectionResponse = await getCategories(sectionId);
    const categories = sectionResponse?.data?.data?.categories || [];
    const target = categories.find((c) => String(c.id) === String(categoryId));
    if (!target) return null;

    const existingContents = Array.isArray(target.contents) ? target.contents : [];
    if (!existingContents.includes(contentId)) return sectionResponse;

    const response = await updateCategories(target.id, {
      contents: existingContents.filter((c) => c !== contentId),
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteCategoriesns = async (id) => {
  try {
    const response = await del(`/sections/categories/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteVideos = async (categoriesId, videoId) => {
  try {
    const response = await del(
      `/sections/categories/${categoriesId}/contents/${videoId}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const postSwapOrderCategoyiesList = async (data) => {
  try {
    const response = await post(`/sections/categories/swap-order`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const postSwapOrderVideoList = async (id, data) => {
  try {
    const response = await post(
      `/sections/categories/${id}/swap-contents-order`,
      data,
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const getPlatformAnalytics = async (platform) => {
  try {
    const response = await get(`/get-analytics/platform`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Phase 1 analytics redesign — new endpoints alongside the two above.
const buildQuery = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") search.set(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const getAnalyticsOverview = async ({ from, to, compare, platform, contentType } = {}) => {
  try {
    const response = await get(`/get-analytics/overview${buildQuery({ from, to, compare, platform, contentType })}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getContentAnalytics = async ({ sort, page, limit, platform, contentType, from, to } = {}) => {
  try {
    const response = await get(`/get-analytics/content${buildQuery({ sort, page, limit, platform, contentType, from, to })}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getContentDrilldown = async (slug) => {
  try {
    const response = await get(`/get-analytics/content/${encodeURIComponent(slug)}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserAnalytics = async ({ from, to, platform } = {}) => {
  try {
    const response = await get(`/get-analytics/users${buildQuery({ from, to, platform })}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getGeoAnalytics = async ({ from, to, limit, platform, contentType } = {}) => {
  try {
    const response = await get(`/get-analytics/geo${buildQuery({ from, to, limit, platform, contentType })}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRealtimeAnalytics = async ({ windowMinutes, platform, contentType } = {}) => {
  try {
    const response = await get(`/get-analytics/realtime${buildQuery({ window_minutes: windowMinutes, platform, contentType })}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const liveChannelCreate = async (data) => {
  try {
    const response = await post(`/live-channel/create`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStreamType = async () => {
  try {
    const response = await get(`/live-channel/stream-type`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getEventType = async () => {
  try {
    const response = await get(`/live-channel/event-type`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getLiveChannelDetails = async (id) => {
  try {
    const response = await get(`/live-channel/${id}`);
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const putLiveChannelUpdate = async (id, data) => {
  try {
    const response = await put(`/live-channel/update/${id}`, data);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getLiveChannelData = async (
  data = {},
  date = "",
  creator = "",
  rating = "",
  genre = "",
  perpage = 20,
  page = 1,
  search = "",
) => {
  try {
    const response = await get(
      `/live-channel?date=${date ? date : ""}&creator=${creator ? creator : ""
      }&rating=${rating ? rating : ""}&genre=${genre ? genre : ""
      }&perpage=${perpage}&page=${page}&search=${encodeURIComponent(search || "")}`,
      data,
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const liveChannelDelete = async (id) => {
  try {
    const response = await del(`/live-channel/delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const creatorsDelete = async (id) => {
  try {
    const response = await del(`/creators/delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// `trustCreator` ticks "publish this creator's content without review" at the
// same moment the application is approved. Omitted/false keeps the creator on
// the normal QC path; the same trust can still be granted later from the
// content-approval screen.
export const approveCreator = async (id, note, trustCreator = false) => {
  try {
    const response = await post(`/creators/approve/${id}`, {
      note,
      trust_creator: !!trustCreator,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// Grant/revoke "publishes without review" on an existing creator. Separate
// from approveCreator because the approval checkbox is only reachable while a
// creator is still Pending — this works at any status.
export const setCreatorTrusted = async (id, isTrusted) => {
  try {
    const response = await post(`/creators/${id}/trusted-status`, {
      is_trusted_creator: !!isTrusted,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const rejectCreator = async (id, note) => {
  try {
    const response = await post(`/creators/reject/${id}`, { note });
    return response;
  } catch (error) {
    throw error;
  }
};

export const requestCreatorCorrection = async (id, note) => {
  try {
    const response = await post(`/creators/request-correction/${id}`, { note });
    return response;
  } catch (error) {
    throw error;
  }
};

// status: "Approved" | "Inactive" (deactivate/reactivate a creator account,
// without deleting it — the safe alternative when a delete is refused
// because the creator has real earnings/payout/watch-time history).
export const creatorStatusChange = async (id, status) => {
  try {
    const response = await post(`/creators/status/${id}`, { status });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSectionMediaLibrary = async (query, page = 1) => {
  try {
    const response = await get(`/all-content?search=${query}&page=${page}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const urlImageUpload = async (data) => {
  try {
    const response = await post(`/url-image-upload`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getCountry = async () => {
  try {
    const response = await fetch('https://api.bunny.net/country', {
      method: 'GET',
      headers: {
        'AccessKey': process.env.REACT_APP_BUNNY_API_KEY,
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
// Geo-locate the logged-in user's request IP → { country, city } (ISO alpha-2
// country like "IN"). Used to auto-fill the Add-Content Country field. Returns
// nulls on localhost / unknown IP; callers should no-op in that case.
export const getGeo = async () => {
  try {
    const response = await get("/geo");
    return response?.data?.data || null;
  } catch (error) {
    return null;
  }
};
export const getLanguage = async (type, key, value) => {
  try {
    const response = await post("/global-key-values", { type, key, value });
    return response;
  } catch (error) {
    throw error;
  }
};

// GET - Fetch all languages for dropdown
export const getAllLanguages = async () => {
  try {
    const response = await get("/global-key-values?type=LANGUAGE");
    return response;
  } catch (error) {
    throw error;
  }
};
export const getTaxonomyByType = async (type) => {
  try {
    const response = await get(`/global-key-values?type=${type}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateTaxonomyValue = async (id, data) => {
  try {
    const response = await put(`/global-key-values/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const deleteTaxonomyValue = async (id) => {
  try {
    const response = await del(`/global-key-values/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const adminContent = async (data) => {
  try {
    const response = await post(`/admin/add-content`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getTrailerType = async () => {
  try {
    const response = await get(
      `/global-key-values?type=TRAILER_TYPE`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
// Cast/Crew refactor — actor management: role list for cast & crew dropdown
export const getCastCrewRole = async () => {
  try {
    const response = await get(
      `/global-key-values?type=CAST_CREW_ROLE`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const GenresDeletebyId = async (categoryId, genreId, data) => {
  try {
    const response = await del(`/sections/categories/${categoryId}/genres/${genreId}`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getAllContent = async (page = 1, type = "all", search = "", genre = "", limit = 20) => {
  try {
    const response = await get(
      `/all-content?page=${page}&type=${type}&search=${search}&genre=${genre}&limit=${limit}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};


// Cast/Crew refactor — actor management: CRUD helpers for /admin/cast-crew-members
export const castCrewMemberCreate = async (data) => {
  try {
    const response = await post(`/admin/cast-crew-members`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const castCrewMemberUpdate = async (id, data) => {
  try {
    const response = await post(`/admin/cast-crew-members/update/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
export const castCrewMemberList = async (perpage = 20, page = 1, search = "") => {
  try {
    const response = await get(
      `/admin/cast-crew-members/list?page=${page}&perpage=${perpage}${
        search ? `&search=${encodeURIComponent(search)}` : ""
      }`
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const castCrewMemberDelete = async (id) => {
  try {
    const response = await del(`/admin/cast-crew-members/delete/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// ===== Subscription Plans (CMS) =====
export const getSubscriptionPlans = async ({ page = 1, limit = 20, search = "", status } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append("search", search);
    if (status !== undefined && status !== "") params.append("status", status);
    const response = await get(`/subscription-plans/list?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subscription plans:", error);
    throw error;
  }
};

export const getSubscriptionPlan = async (id) => {
  try {
    const response = await get(`/subscription-plans/show/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subscription plan:", error);
    throw error;
  }
};

export const createSubscriptionPlan = async (payload) => {
  try {
    const response = await post(`/subscription-plans/create`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating subscription plan:", error);
    throw error;
  }
};

export const updateSubscriptionPlan = async (id, payload) => {
  try {
    const response = await post(`/subscription-plans/update/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating subscription plan:", error);
    throw error;
  }
};

export const updateSubscriptionPlanStatus = async (id, status) => {
  try {
    const response = await post(`/subscription-plans/status/${id}`, { status });
    return response.data;
  } catch (error) {
    console.error("Error updating subscription plan status:", error);
    throw error;
  }
};

export const deleteSubscriptionPlan = async (id) => {
  try {
    const response = await del(`/subscription-plans/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting subscription plan:", error);
    throw error;
  }
};

// Clear orphan Stripe IDs from a single plan's prices. Use after switching the
// Stripe account on the server. The next "Save" on the plan will create fresh
// Stripe products/prices on the new account.
export const resetPlanStripeSync = async (id) => {
  try {
    const response = await post(`/subscription-plans/reset-stripe-sync/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error resetting plan Stripe sync:", error);
    throw error;
  }
};

// Same, but for ALL plans at once (one-click fix after a server-wide Stripe
// account swap).
export const resetAllPlansStripeSync = async () => {
  try {
    const response = await post(`/subscription-plans/reset-stripe-sync-all`);
    return response.data;
  } catch (error) {
    console.error("Error resetting all plans Stripe sync:", error);
    throw error;
  }
};

// ===== Promos (CMS) =====
export const getPromos = async ({ page = 1, limit = 20, search = "", status } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append("search", search);
    if (status !== undefined && status !== "") params.append("status", status);
    const response = await get(`/promos/list?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching promos:", error);
    throw error;
  }
};

export const getPromo = async (id) => {
  try {
    const response = await get(`/promos/show/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching promo:", error);
    throw error;
  }
};

export const createPromo = async (payload) => {
  try {
    const response = await post(`/promos/create`, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating promo:", error);
    throw error;
  }
};

export const updatePromo = async (id, payload) => {
  try {
    const response = await post(`/promos/update/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating promo:", error);
    throw error;
  }
};

export const updatePromoStatus = async (id, status) => {
  try {
    const response = await post(`/promos/status/${id}`, { status });
    return response.data;
  } catch (error) {
    console.error("Error updating promo status:", error);
    throw error;
  }
};

export const deletePromo = async (id) => {
  try {
    const response = await del(`/promos/delete/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting promo:", error);
    throw error;
  }
};

/* ============================================================
   CREATOR MONETIZATION (Admin) — backend prefix /admin/monetization
   (baseURL already includes /api/v1)
   ============================================================ */

// --- Global settings ---
export const getMonetizationSettings = async () => {
  try {
    const response = await get(`/admin/monetization/settings`);
    return response.data;
  } catch (error) {
    console.error("Error fetching monetization settings:", error);
    throw error;
  }
};

export const updateMonetizationSettings = async (payload) => {
  try {
    const response = await put(`/admin/monetization/settings`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating monetization settings:", error);
    throw error;
  }
};

// --- Creators + per-creator revenue config ---
export const getMonetizationCreators = async ({ page = 1, limit = 20, search = "", status = "" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append("search", search);
    if (status && status !== "all") params.append("status", status);
    const response = await get(`/admin/monetization/creators?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching monetization creators:", error);
    throw error;
  }
};

export const getCreatorRevenueConfig = async (userId) => {
  try {
    const response = await get(`/admin/monetization/creators/${userId}/config`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator revenue config:", error);
    throw error;
  }
};

export const updateCreatorRevenueConfig = async (userId, payload) => {
  try {
    const response = await put(`/admin/monetization/creators/${userId}/config`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating creator revenue config:", error);
    throw error;
  }
};

export const getCreatorMonetizationAnalytics = async (userId, { year } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    const response = await get(`/admin/monetization/creators/${userId}/analytics?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator monetization analytics:", error);
    throw error;
  }
};

// --- Platform analytics ---
export const getReferralPerformance = async ({ year, month } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/admin/monetization/referrals/performance?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching referral performance:", error);
    throw error;
  }
};

export const getWatchAnalytics = async ({ year, month } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/admin/monetization/watch-analytics?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching watch analytics:", error);
    throw error;
  }
};

export const getTvodSummary = async ({ limit } = {}) => {
  try {
    const params = new URLSearchParams();
    if (limit) params.append("limit", limit);
    const response = await get(`/admin/monetization/tvod-summary?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching TVOD summary:", error);
    throw error;
  }
};

// --- Revenue engine ---
export const runRevenueEngine = async (payload = {}) => {
  try {
    const response = await post(`/admin/monetization/revenue-run`, payload);
    return response.data;
  } catch (error) {
    console.error("Error running revenue engine:", error);
    throw error;
  }
};

export const getRevenueRuns = async ({ year } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    const response = await get(`/admin/monetization/revenue-runs?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching revenue runs:", error);
    throw error;
  }
};

// --- Payouts ---
export const getMonetizationPayouts = async ({ page = 1, limit = 50, status = "", year, month } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/admin/monetization/payouts?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching payouts:", error);
    throw error;
  }
};

// Watch-time anti-gaming — "suspected activity" panel (shadow mode: viewing
// and resolving a finding never changes any payout).
export const getWatchFraudLog = async ({ page = 1, limit = 50, status = "", rule = "" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    if (rule) params.append("rule", rule);
    const response = await get(`/admin/monetization/watch-fraud-log?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching watch-fraud log:", error);
    throw error;
  }
};

export const getWatchFraudLogDetail = async (id) => {
  try {
    const response = await get(`/admin/monetization/watch-fraud-log/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching watch-fraud finding:", error);
    throw error;
  }
};

export const resolveWatchFraudLog = async (id, payload = {}) => {
  try {
    const response = await post(`/admin/monetization/watch-fraud-log/${id}/resolve`, payload);
    return response.data;
  } catch (error) {
    console.error("Error resolving watch-fraud finding:", error);
    throw error;
  }
};

// Confirming is the one action here that actually stops money counting
// toward a payout; resolving above only records that a person looked.
export const confirmWatchFraudLog = async (id, payload = {}) => {
  try {
    const response = await post(`/admin/monetization/watch-fraud-log/${id}/confirm`, payload);
    return response.data;
  } catch (error) {
    console.error("Error confirming watch-fraud finding:", error);
    throw error;
  }
};

// For audience findings: excludes ONE viewer's watch time on that creator,
// leaving the creator's genuine fans paid.
export const confirmWatchFraudViewer = async (id, payload = {}) => {
  try {
    const response = await post(`/admin/monetization/watch-fraud-log/${id}/confirm-viewer`, payload);
    return response.data;
  } catch (error) {
    console.error("Error excluding viewer:", error);
    throw error;
  }
};

export const unconfirmWatchFraudLog = async (id) => {
  try {
    const response = await post(`/admin/monetization/watch-fraud-log/${id}/unconfirm`, {});
    return response.data;
  } catch (error) {
    console.error("Error undoing watch-fraud confirmation:", error);
    throw error;
  }
};

export const runWatchFraudScan = async () => {
  try {
    const response = await post(`/admin/monetization/watch-fraud-scan`);
    return response.data;
  } catch (error) {
    console.error("Error running watch-fraud scan:", error);
    throw error;
  }
};

export const generatePayouts = async (payload = {}) => {
  try {
    const response = await post(`/admin/monetization/payouts/generate`, payload);
    return response.data;
  } catch (error) {
    console.error("Error generating payouts:", error);
    throw error;
  }
};

export const approvePayout = async (id) => {
  try {
    const response = await post(`/admin/monetization/payouts/${id}/approve`);
    return response.data;
  } catch (error) {
    console.error("Error approving payout:", error);
    throw error;
  }
};

export const markPayoutPaid = async (id, payload = {}) => {
  try {
    const response = await post(`/admin/monetization/payouts/${id}/mark-paid`, payload);
    return response.data;
  } catch (error) {
    console.error("Error marking payout paid:", error);
    throw error;
  }
};

export const payPayoutViaStripe = async (id) => {
  try {
    const response = await post(`/admin/monetization/payouts/${id}/pay-stripe`);
    return response.data;
  } catch (error) {
    console.error("Error sending Stripe payout:", error);
    throw error;
  }
};

// CSV export — downloads a file via blob response.
export const exportPayoutsCsv = async ({ year, month, status } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    if (status) params.append("status", status);
    const response = await get(`/admin/monetization/payouts/export?${params.toString()}`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `payouts_${year || "all"}_${month || "all"}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error exporting payouts CSV:", error);
    throw error;
  }
};

// Multi-sheet Excel ledger (Summary + Watch Pool + Affiliate + TVOD + Payout
// Status) — full transaction detail, not just totals. creatorId omitted
// means every creator.
export const exportPayoutLedgerXlsx = async ({ start, end, creatorId } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start) params.append("start", start);
    if (end) params.append("end", end);
    if (creatorId) params.append("creator_id", creatorId);
    const response = await get(`/admin/monetization/payouts/export-ledger?${params.toString()}`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `payout_ledger_${start || "default"}_${end || "default"}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error exporting payout ledger:", error);
    throw error;
  }
};

/* ============================================================
   CREATOR MONETIZATION (Creator) — backend prefix /creator/monetization
   Creator sees only their own data. (baseURL includes /api/v1)
   ============================================================ */

export const getMyCreatorOverview = async () => {
  try {
    const response = await get(`/creator/monetization/overview`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator overview:", error);
    throw error;
  }
};

export const getMyCreatorReferral = async () => {
  try {
    const response = await get(`/creator/monetization/referral`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator referral:", error);
    throw error;
  }
};

export const getMyCreatorReferralList = async ({ page = 1, limit = 20, status = "" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (status) params.append("status", status);
    const response = await get(`/creator/monetization/referral/list?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator referral list:", error);
    throw error;
  }
};

export const getMyCreatorContentAnalytics = async ({ year, month } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/creator/monetization/content-analytics?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator content analytics:", error);
    throw error;
  }
};

export const getMyCreatorRevenue = async ({ year } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    const response = await get(`/creator/monetization/revenue?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator revenue:", error);
    throw error;
  }
};

// Real, transaction-level breakdown for a period's referral commission:
// gross charge -> Stripe's real fee -> net -> the commission on that net
// figure. year/month default to the current period on the backend.
export const getMyCreatorRevenueBreakdown = async ({ year, month } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/creator/monetization/revenue-breakdown?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator revenue breakdown:", error);
    throw error;
  }
};

// Real transaction-level breakdown of one period's total earnings, across all
// three sources (watch pool, affiliate, TVOD) — "I earned $5.80, what's that
// actually made of?" year/month default to the current period on the backend.
export const getMyCreatorEarningsBreakdown = async ({ year, month } = {}) => {
  try {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    const response = await get(`/creator/monetization/earnings-breakdown?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator earnings breakdown:", error);
    throw error;
  }
};

// A creator's own multi-sheet Excel ledger — always scoped to them by the
// backend (there's no creator_id param here to pass anyone else's).
export const exportMyPayoutLedgerXlsx = async ({ start, end } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start) params.append("start", start);
    if (end) params.append("end", end);
    const response = await get(`/creator/monetization/export-ledger?${params.toString()}`, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `my_payout_ledger_${start || "default"}_${end || "default"}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    return true;
  } catch (error) {
    console.error("Error exporting my payout ledger:", error);
    throw error;
  }
};

export const getMyCreatorWeeklyWatchtime = async () => {
  try {
    const response = await get(`/creator/monetization/weekly-watchtime`);
    return response.data;
  } catch (error) {
    console.error("Error fetching weekly watchtime:", error);
    throw error;
  }
};

export const getMyCreatorContentDetail = async (videoMetaId) => {
  try {
    const response = await get(`/creator/monetization/content/${videoMetaId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching content detail:", error);
    throw error;
  }
};

export const getMyCreatorPayouts = async () => {
  try {
    const response = await get(`/creator/monetization/payouts`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator payouts:", error);
    throw error;
  }
};

export const getMyCreatorPayoutAccount = async () => {
  try {
    const response = await get(`/creator/monetization/payout-account`);
    return response.data;
  } catch (error) {
    console.error("Error fetching creator payout account:", error);
    throw error;
  }
};

export const startMyCreatorOnboarding = async (payload = {}) => {
  try {
    const response = await post(`/creator/monetization/payout-account/onboard`, payload);
    return response.data;
  } catch (error) {
    console.error("Error starting creator onboarding:", error);
    throw error;
  }
};

export const refreshMyCreatorOnboarding = async () => {
  try {
    const response = await post(`/creator/monetization/payout-account/refresh`, {});
    return response.data;
  } catch (error) {
    console.error("Error refreshing creator onboarding:", error);
    throw error;
  }
};
export const bulkEpisodeUploadApi = async (seriesId, seasonId, data) => {
  try {
    const response = await post(
      `/series/${seriesId}/seasons/${seasonId}/episodes/bulk`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const bulkZipUploadApi = async (seriesId, seasonId, data) => {
  try {
    const response = await post(
      `/series/${seriesId}/seasons/${seasonId}/episodes/bulk/zip`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const getBulkEpisodeTemplateApi = async () => {
  try {
    const response = await get(`/series/episodes/bulk/template`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const getBulkEpisodeZipTemplateApi = async () => {
  try {
    const response = await get(`/series/episodes/bulk/zip-template`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const getBulkUploadProgressApi = async (bulkUploadId) => {
  try {
    const response = await get(`/bulk-uploads/${bulkUploadId}/progress`);
    return response;
  } catch (error) {
    throw error;
  }
};
export const getBulkUploadTasksApi = async (bulkUploadId, status) => {
  try {
    const url = status
      ? `/bulk-uploads/${bulkUploadId}/tasks?status=${status}`
      : `/bulk-uploads/${bulkUploadId}/tasks`;
    const response = await get(url);
    return response;
  } catch (error) {
    throw error;
  }
};

// ---- Tenant CDN / Bunny setup (tenant-specific) -----------------------
export const getBunnySetupStatus = async () => {
  try {
    const response = await get(`/bunny-setup/status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching CDN setup status:", error);
    throw error;
  }
};
export const postBunnySetup = async ({ provider, apiKey }) => {
  try {
    const response = await post(`/bunny-setup`, { provider, apiKey });
    return response.data;
  } catch (error) {
    console.error("Error setting up CDN:", error);
    throw error;
  }
};

// Admin-only ("Open creator portal"): start a 1-hour session as an approved
// creator. Returns the same shape as /login plus `impersonation`.
export const impersonateCreator = async (creatorId) => {
  try {
    const response = await post(`/admin/creators/${creatorId}/impersonate`);
    return response;
  } catch (error) {
    console.error("Error opening creator portal:", error);
    throw error;
  }
};

// "1 more hour" for the current creator-portal session. Returns a fresh token
// and the new expiry ({ token, expire_date, expires_at }).
export const extendImpersonation = async () => {
  try {
    const response = await post(`/impersonation/extend`);
    return response;
  } catch (error) {
    console.error("Error extending creator portal session:", error);
    throw error;
  }
};

// Ends the current creator-portal session server-side (revokes its token).
export const stopImpersonation = async () => {
  try {
    const response = await post(`/impersonation/stop`);
    return response;
  } catch (error) {
    console.error("Error ending creator portal session:", error);
    throw error;
  }
};

// Admin-only: re-send the invitation email to a creator who hasn't accepted
// it yet (status "Invited").
export const resendCreatorInvite = async (creatorId) => {
  try {
    const response = await post(`/creators/${creatorId}/invite/resend`);
    return response;
  } catch (error) {
    console.error("Error resending creator invite:", error);
    throw error;
  }
};

// Creator-only: Help & Support dropdown options [{ key, label }]. "Other" is last.
export const creatorSupportCategories = async () => {
  try {
    const response = await get(`/creators/support/categories`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creator-only: the creator's own Help & Support tickets ("My requests").
export const creatorSupportTickets = async ({ page = 1, limit = 10 } = {}) => {
  try {
    const response = await get(`/creators/support/tickets?page=${page}&limit=${limit}`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Creator-only: Help & Support form. Expects { category, subject, message, page }.
// Backend emails the support inbox with the creator as replyTo.
export const creatorSupportRequest = async (data) => {
  try {
    const response = await post(`/creators/support`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Public (no login): same category list, for the login page Contact Support
// form and the public Help Center.
export const creatorPublicSupportCategories = async () => {
  try {
    const response = await get(`/creators/support/public-categories`);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Public (no login): Contact Support from the creator login page, for a
// creator who can't sign in. Expects FormData: name, email, category, subject,
// message, page, plus up to 3 "attachments" files.
export const creatorGuestSupportRequest = async (data) => {
  try {
    const response = await post(`/creators/support/guest`, data);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const addCustomFontColor = async (color) => {
  try {
    const response = await post(`/config/theme/custom-font-colors`, { color });
    return response;
  } catch (error) {
    throw error;
  }
};

export const removeCustomFontColor = async (color) => {
  try {
    const response = await del(`/config/theme/custom-font-colors/${encodeURIComponent(color)}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// ── Support Tickets (admin) ────────────────────────────────────────────────
// Creator Help & Support + viewer website Contact Support submissions
// (`source` = creator | viewer). Gated by the `support` RBAC module.
export const getSupportTickets = async ({ page = 1, limit = 20, status = "", source = "", category = "", q = "" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (status && status !== "all") params.set("status", status);
    if (source) params.set("source", source);
    if (category) params.set("category", category);
    if (q) params.set("q", q);
    const response = await get(`/admin/support-tickets?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching support tickets:", error);
    throw error;
  }
};

export const getSupportTicketCounts = async () => {
  try {
    const response = await get(`/admin/support-tickets/counts`);
    return response.data;
  } catch (error) {
    console.error("Error fetching support ticket counts:", error);
    throw error;
  }
};

export const getSupportTicket = async (id) => {
  try {
    const response = await get(`/admin/support-tickets/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching support ticket:", error);
    throw error;
  }
};

export const updateSupportTicket = async (id, payload = {}) => {
  try {
    const response = await post(`/admin/support-tickets/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating support ticket:", error);
    throw error;
  }
};

// Emails the requester from the app; an open ticket moves to in_progress.
export const replySupportTicket = async (id, { subject, message }) => {
  try {
    const response = await post(`/admin/support-tickets/${id}/reply`, { subject, message });
    return response.data;
  } catch (error) {
    console.error("Error replying to support ticket:", error);
    throw error;
  }
};
